import { Component } from '@angular/core';
import packageJson from '../../../../package.json';
import { StorageService } from './services/StorageService';
import { ActivatedRoute, NavigationCancel, NavigationEnd, NavigationError, NavigationStart, Router, RouterEvent } from '@angular/router';
import { Title } from '@angular/platform-browser';
import { filter, map } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
import * as AOS from 'aos';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  standalone: false,
})
export class AppComponent {
  appTitle = 'general.Thrwty';
  public version: string = packageJson.version;

  moduleLoading: boolean = false;
  intervalId: any;
  progressValue = 0;

  constructor(
    public storageService: StorageService,
    private router: Router,
    private title: Title,
    private translate: TranslateService
  ) {
    router.events.subscribe((event: any) => {
      this.navigationInterceptor(event);
    });
    this.storageService.changes.subscribe(data => {
      // if (data?.key == 'language' || data?.key == 'authUser') {
      // localStorage.removeItem('authUser');
      window.location.reload();
      // }
    });

    var lang = localStorage.getItem('language') || 'ar';
    localStorage.setItem('language', lang);
    var style = 'assets/css/ar/style.css';
    var dir = 'rtl';
    if (lang == 'en') {
      style = 'assets/css/en/style.css';
      dir = 'ltr';
    }
    let buildNumber = this.version;
    style += buildNumber ? '?vr=' + buildNumber : '';
    document.getElementById('mainStyle')?.setAttribute('href', style);
    document.getElementById('html')?.setAttribute('lang', lang);
    document.getElementById('html')?.setAttribute('dir', dir);
  }
  ngOnInit() {
    this.translate.get(this.appTitle).subscribe(title => {
      this.title.setTitle(title);
    });
    this.router.events
      .pipe(
        filter((event) => event instanceof NavigationEnd),
        map(() => {
          let route: ActivatedRoute = this.router.routerState.root;
          let routeTitle = '';
          while (route!.firstChild) {
            route = route.firstChild;
          }
          if (route.snapshot.data['title']) {
            routeTitle = route!.snapshot.data['title'];
          }
          return routeTitle;
        })
      )
      .subscribe((title: string) => {
        if (title) {
          this.translate.get('header.' + title).subscribe(transTitle => {
            this.title.setTitle(`${this.translate.instant(this.appTitle)} - ${transTitle}`);
          });
        }
      });

    AOS.init({
      duration: 800,
      easing: 'ease-in-out',
      once: true,
      mirror: false
    });
  }

  // Shows and hides the moduleLoading spinner during RouterEvent changes
  navigationInterceptor(event: RouterEvent): void {
    if (event instanceof NavigationStart) {
      this.moduleLoading = true;
      this.progressValue = 0;

      this.intervalId = setInterval(() => {
        if (this.progressValue < 90) {
          this.progressValue += 5;
        }
      }, 100);
    } else if (
      event instanceof NavigationEnd ||
      event instanceof NavigationCancel ||
      event instanceof NavigationError
    ) {
      this.progressValue = 100;
      setTimeout(() => {
        this.moduleLoading = false;
        clearInterval(this.intervalId);
        this.intervalId = null;
      }, 0);
    }
  }
}
